var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.loading)?_c(_setup.CInfoPageTemplate,{attrs:{"content-label":_vm.$t('enterprise.subscription-terms'),"content-text":_setup.content,"button-text":_vm.$t('enterprise.subscribe')},on:{"button-click":_setup.goSubscription}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }